<template>
  <div class="edit-platform">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">申请交易</div>
    <div class="order-detail-basic">
      <el-form :model="chargeForm" :rules="rules" ref="chargeForm" label-width="120px" class="demo-chargeForm">
        <el-form-item label="交易方式:" prop="tradeMethod" class="">
          <el-select v-model="chargeForm.tradeMethod" placeholder="请选择" clearable>
            <el-option v-for="(v, k) in $config.vpayChargeExtTradeMethod" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台号:" prop="code">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
          </el-autocomplete>
          <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
          <span v-show="show">平台名称:{{ storeName }}</span>
        </el-form-item>
        <el-form-item label="金额:" prop="amount" v-if='chargeForm.tradeMethod !== "CHARGE_OFFLINE_BONUS"'>
          <el-input v-model="chargeForm.amount" clearable></el-input>
        </el-form-item>
        <el-form-item label="虚拟金额:" prop="bonus" v-if='chargeForm.tradeMethod === "CHARGE_OFFLINE_BONUS"'>
          <el-input v-model="chargeForm.bonus" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="chargeForm.note" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="edit-button" style='justify-content:flex-start; padding-left:200px'>
        <el-button type="primary" round @click="submitForm('chargeForm')">申请交易</el-button>
      </div>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { chargeApply, bankAccountGetAll } from '@/api/epay'
import { storeQueryListByCode, storeQueryByStoreCode } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'VpayChargeApplyExt',
  components: {
    CombinedDialog
  },
  data () {
    var checkAmount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写金额'))
      } else if (!/^([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(value)) {
        callback(new Error('请输入正确的金额，最多两位小数'))
      } else {
        callback()
      }
    }
    var bonus = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写虚拟金额'))
      } else if (!/^([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(value)) {
        callback(new Error('请输入正确的虚拟金额，最多两位小数'))
      } else {
        callback()
      }
    }
    return {
      show: false,
      storeName: '',
      chargeForm: {
        amount: '',
        bonus: '',
        note: '',
        tradeMethod: '',
        storeId: ''
      },
      rules: {
        amount: [
          { validator: checkAmount, trigger: 'blur' }
        ],
        bonus: [
          { validator: bonus, trigger: 'blur' }
        ]
      },
      date: '',
      code: '',
      bankList: []
    }
  },
  watch: {
    date (val) {
    },
    code () {
      this.show = false
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    // this.getBankList()
  },
  methods: {
    // 获取收款账户列表
    // getBankList () {
    //   bankAccountGetAll().then(res => {
    //     this.bankList = res.data.data
    //   })
    // },
    // 验证平台
    verifyStore () {
      storeQueryByStoreCode(this.code).then(res => {
        if (res.data.data.exist) {
          this.chargeForm.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.show = true
        } else {
          this.$message.error('平台不存在')
        }
      })
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    submitForm (formName) {
      if (!this.show) {
        this.$message.error('请验证平台')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let vo = JSON.parse(JSON.stringify(this.chargeForm))
          if (this.chargeForm.tradeMethod === 'CHARGE_OFFLINE_BONUS') {
            vo.amount = 0
          } else {
            vo.bonus = 0
          }
          chargeApply(vo).then(res => {
            if (res.data.success) {
              this.$message({ message: '申请成功', type: 'success' })
              this.$router.push({ path: '/epay/vpayCharge' })
            }
          })
        }
      })
    },
    upload (e) {
      var file = e.target.files[0]
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.chargeForm.bankVoucher = res
      })
    },
    handleSelect (item) {
      this.chargeForm.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    }
  }
}
</script>
 <style scoped lang="less">
 // @import "index";
 .edit-platform {
   .el-input {
     @{deep} .el-input__inner {
       //color: #F56C6C;
       -moz-appearance: textfield;
     }
 
     @{deep} .el-input__inner::-webkit-inner-spin-button,
     @{deep} .el-input__inner::-webkit-outer-spin-button {
       -webkit-appearance: none;
       margin: 0;
     }
   }
 }
 
 @deep: ~">>>";
 </style>
